import React from 'react';
import { Button, Col, Collapse, InputNumber, Row, Space, Typography } from 'antd';
import { SaveOutlined, UndoOutlined } from '@ant-design/icons';
import { SIGNATURE_LAYOUT_DEFAULTS, normalizeSignatureLayout } from '../utils/signatureLayout';

const { Text } = Typography;

export default function SignatureLayoutControls({ documentType, value, onChange, onSave, saving }) {
  const layout = normalizeSignatureLayout(value, documentType);
  const update = (field, nextValue) => onChange?.(normalizeSignatureLayout({ ...layout, [field]: nextValue }, documentType));
  const reset = () => onChange?.({ ...SIGNATURE_LAYOUT_DEFAULTS[documentType] });

  return <Collapse
    size="small"
    style={{ marginBottom: 10, flexShrink: 0 }}
    items={[{
      key: 'signature-layout',
      label: 'ปรับตำแหน่งและขนาดลายเซ็น',
      children: <>
        <Row gutter={[10, 10]} align="bottom">
          <Col xs={12} md={6}>
            <Text type="secondary">แนวนอน</Text>
            <InputNumber min={-120} max={120} value={layout.x} onChange={value => update('x', value)} addonAfter="px" style={{ width: '100%' }} />
          </Col>
          <Col xs={12} md={6}>
            <Text type="secondary">แนวตั้ง</Text>
            <InputNumber min={-100} max={100} value={layout.y} onChange={value => update('y', value)} addonAfter="px" style={{ width: '100%' }} />
          </Col>
          <Col xs={12} md={6}>
            <Text type="secondary">ความกว้าง</Text>
            <InputNumber min={40} max={180} value={layout.width} onChange={value => update('width', value)} addonAfter="px" style={{ width: '100%' }} />
          </Col>
          <Col xs={12} md={6}>
            <Space wrap>
              <Button icon={<UndoOutlined />} onClick={reset}>ค่าเริ่มต้น</Button>
              <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={onSave}>บันทึก</Button>
            </Space>
          </Col>
        </Row>
        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
          ค่าบวก: เลื่อนไปทางขวา/ด้านล่าง · ค่าลบ: เลื่อนไปทางซ้าย/ด้านบน ตัวอย่าง PDF จะอัปเดตอัตโนมัติ
        </Text>
      </>
    }]}
  />;
}
